import { Type } from './Type';
export function getTypeFromHostname() {
    var hostname = window.location.hostname;
    var hostNameRegex = new RegExp('team');
    /*
      hostname === 'team.lendi.com.au' ||
      hostname === 'team.lendi-stg.net' ||
      hostname === 'team.lendi-preprod.net' ||
      hostname === 'team.lendi-dev.net' ||
      hostname === 'team.aussie.com.au' ||
      hostname === 'team.aussie-stg.com.au' ||
      hostname === 'team.aussie-preprod.com.au' ||
      hostname === 'team.aussie-dev.com.au' ||
    */
    // team
    if (hostNameRegex.test(hostname) || hostname.startsWith('tools.')) {
        return Type.Team;
    }
    // lendi customer
    if (hostname === 'www.lendi.com.au' ||
        hostname === 'www.lendi-stg.net' ||
        hostname === 'www.lendi-dev.net' ||
        hostname === 'www.lendi-preprod.net') {
        return Type.Customer;
    }
    // aussie customer
    if (hostname === 'www.aussie.com.au' ||
        hostname === 'www.aussie-stg.com.au' ||
        hostname === 'www.aussie-dev.com.au' ||
        hostname === 'www.aussie-preprod.com.au') {
        return Type.Customer;
    }
    // default to customer
    return Type.Customer;
}
//# sourceMappingURL=getTypeFromHostname.js.map